module.exports = {"430103002":"坡子街街道","430103004":"城南路街道","430103005":"裕南街街道","430103006":"金盆岭街道","430103007":"新开铺街道","430103008":"青园街道","430103009":"桂花坪街道","430103010":"赤岭路街道","430103011":"文源街道","430103012":"先锋街道","430103013":"黑石铺街道","430103014":"大托铺街道","430103015":"暮云街道","430103016":"南托街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430103.json
// module id = 1929
// module chunks = 0